import {Component, Input} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {Internet, Kommunikationsmittel, Telefonnummer} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-kommunikationsmittel',
  templateUrl: './kommunikationsmittel.component.html',
  styleUrls: ['./kommunikationsmittel.component.scss']
})
export class KommunikationsmittelComponent extends FormBaseComponent<Kommunikationsmittel> {

  @Input()
  public maxTelefonnummern: number;

  @Input()
  public disableInternet = false;

  @Input()
  public stammdatenTelefonnummern: Array<Telefonnummer>;

  @Input()
  public stammdatenInternetadressen: Internet | Array<Internet>;

  constructor(private readonly formBuilder: FormBuilder,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  public addTelefonnummer(): void {
    this.data.telefonnummern.push({});
  }

  public removeTelefonnummer(index: number): void {
    this.data.telefonnummern.splice(index, 1);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({});

    if (!this.data.telefonnummern || this.data.telefonnummern.length === 0) {
      this.data.telefonnummern = [{}];
    }
  }
}
